import { API } from "../utils/constants";

export const getStoreItems = async () => {
  try {
    const response = await fetch(`${API}/store/items`);
    if (!response.ok) throw new Error("Failed to fetch items");
    return await response.json();
  } catch (error) {
    console.error("Error fetching store items:", error);
    return [];
  }
};

export const purchaseItem = async (uid: string, itemId: string) => {
  const response = await fetch(`${API}/store/purchase`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ uid, itemId }),
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || "Purchase failed");
  }
  return data;
};
